export var Modules;
(function (Modules) {
    Modules["Dashboard"] = "Dashboard";
    Modules["KPIDashboard"] = "KPIDashboard";
    Modules["Leads"] = "Leads";
    Modules["WorkPreparation"] = "WorkPreparation";
    Modules["Users"] = "Users";
    //RolePermissions = "RolePermissions",
    Modules["RoleManagement"] = "RoleManagement";
    Modules["ChangeObjectStatus"] = "ChangeObjectStatus";
    Modules["Objects"] = "Objects";
    Modules["Contacts"] = "Contacts";
    // Item #9 — manual revenue-attribution override screen. Must match the ScreenName/Controller
    // seeded by the backend's AddRevenueAttributionPermission migration, or every permission check
    // silently returns false and the screen is invisible/inaccessible.
    Modules["RevenueAttribution"] = "RevenueAttribution";
})(Modules || (Modules = {}));
export var ModuleActions;
(function (ModuleActions) {
    ModuleActions["Create"] = "Create";
    ModuleActions["Read"] = "Read";
    ModuleActions["Manage"] = "Manage";
    ModuleActions["Delete"] = "Delete";
})(ModuleActions || (ModuleActions = {}));
